export default "__VITE_ASSET__6c9628ed__"